//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    objectProp: {
      type: Object,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  computed: {
    orderedColumns() {
      return this.orderColumns(this.objectProp.field_mappings);
    },
    tableData() {
      return this.orderedColumns.map(column => {
        return this.getFieldValue(column.field_id);
      });
    },
  },
  methods: {
    getFieldValue(columnFieldId) {
      let field = this.fields.find(field => field.id == columnFieldId);
      return field ? field.name : "";
    },
    orderColumns(sortableColumns) {
      return sortableColumns.sort((a, b) => a.column.localeCompare(b.column));
    },
  },
};
